<template>
  <div class="main-not">
    <div class="text">ไม่มีการให้สิทธิ์การเข้าถึง (Not SessionToken)</div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
div.main-not {
  margin: 0;
  padding: 0;
  position: relative;
  height: 100vh;
  width: 100%;
  div.text {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 3vw;
    font-weight: bold;
  }
}
</style>